// Telemetry must be imported before React so the NR Browser Agent initializes
// before any components render. No-ops when VITE_NR_BROWSER_KEY is absent.
import './lib/telemetry';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from './components/ErrorBoundary';
import { App } from './App';
import './styles/global.css';

const container = document.getElementById('app');
if (!container) {
  throw new Error('#app root element not found in index.html');
}

createRoot(container).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
